import React from 'react';
import { Phone, AlertTriangle, TrendingDown } from 'lucide-react';
export function PowerStroke64LPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-7615">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-7616">
        <div className="container mx-auto px-4" data-id="element-7617">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-7618">
            Ford 6.4L Powerstroke Engine Repair
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-7619">
            Expert Service for 6.4L Powerstroke Diesel Engines
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-7620">
        <div className="max-w-4xl mx-auto" data-id="element-7621">
          {/* Three Engine Models */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7622">
            <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-7623">
              <div className="text-center" data-id="element-7624">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/7.3.jpg?opt=w3" alt="7.3 Powerstroke" className="w-full h-auto rounded-lg mb-4" data-id="element-7625" />
                <a href="/services/powerstroke-7-3" className="text-lg font-bold text-[#B1050B] hover:text-[#8A0408] transition-colors" data-id="element-7626">
                  7.3 Power Stroke
                </a>
                <p className="font-semibold text-gray-700 mt-2" data-id="element-7627">The "Good"</p>
              </div>

              <div className="text-center" data-id="element-7628">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/6.0l.jpg?opt=w3" alt="6.0 Powerstroke" className="w-full h-auto rounded-lg mb-4" data-id="element-7629" />
                <a href="/services/powerstroke-6-0" className="text-lg font-bold text-[#B1050B] hover:text-[#8A0408] transition-colors" data-id="element-7630">
                  6.0 Power Stroke
                </a>
                <p className="font-semibold text-gray-700 mt-2" data-id="element-7631">The "Bad"</p>
              </div>

              <div className="text-center" data-id="element-7632">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/imagesCAB65B34.jpg?opt=w3" alt="6.4 Powerstroke" className="w-full h-auto rounded-lg mb-4" data-id="element-7633" />
                <p className="text-lg font-bold text-gray-900" data-id="element-7634">
                  6.4 Power Stroke
                </p>
                <p className="font-semibold text-gray-700 mt-2" data-id="element-7635">The "Ugly"</p>
              </div>
            </div>
          </div>

          {/* Engine Overview */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7636">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-7637">
              The 6.4 PowerStroke
            </h2>

            <p className="text-gray-700 mb-4" data-id="element-7638">
              The 6.4 L Power Stroke, used in 2008 model year Ford Super Duty
              trucks, is a V8 turbodiesel engine. The engine has a sequential
              twin-turbo intercooled forced induction system. The engine also
              uses a high pressure common rail fuel injection system. It
              produces 350 hp (260 kW) at 3000 rpm and 650 ft·lbf (880 N·m) of
              torque at 2000 rpm.
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-500 p-6 mb-4" data-id="element-7639">
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7640">
                Technical Specifications:
              </h3>
              <ul className="space-y-2 text-gray-700" data-id="element-7641">
                <li data-id="element-7642">
                  <strong data-id="element-7643">Power:</strong> 350 hp (260 kW) @ 3000 rpm
                </li>
                <li data-id="element-7644">
                  <strong data-id="element-7645">Torque:</strong> 650 ft·lbf (880 N·m) @ 2000 rpm
                </li>
                <li data-id="element-7646">
                  <strong data-id="element-7647">Induction:</strong> Sequential twin-turbo intercooled
                  forced induction
                </li>
                <li data-id="element-7648">
                  <strong data-id="element-7649">Fuel System:</strong> High pressure common rail fuel
                  injection
                </li>
              </ul>
            </div>

            <p className="text-gray-700 mb-4" data-id="element-7650">
              This engine will also be used in International trucks and buses
              under the name <strong data-id="element-7651">MaxxForce 7</strong>. However, the
              MaxxForce 7 will not have the sequential turbocharger system;
              rather, it will use a single stage variable vane turbocharger.
              Displacement and injector systems are the same. In MaxxForce 7
              guise, the engine will produce between 200-230 hp and 580–620
              ft·lbf of torque.
            </p>

            <p className="text-gray-700" data-id="element-7652">
              For the 2010 model year, Navistar has upgraded the MaxxForce 7
              with dual sequential turbochargers, giving it a new power range
              (220-300 hp @ 2600 rpm and 520–660 ft·lbf of torque @ 1600-2200
              rpm).
            </p>
          </div>

          {/* Fuel Economy Issues */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7653">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center flex items-center justify-center" data-id="element-7654">
              <TrendingDown className="mr-3 text-red-600" size={32} data-id="element-7655" />
              The Biggest Complaint: Poor Fuel Economy
            </h2>

            <div className="bg-red-50 border-l-4 border-red-500 p-6 mb-6" data-id="element-7656">
              <p className="text-gray-800 font-semibold" data-id="element-7657">
                The biggest complaint we have heard from our customers is poor
                fuel economy. Read below - these posts are taken from internet
                blogs:
              </p>
            </div>

            {/* Customer Testimonial 1 */}
            <div className="bg-gray-50 border-l-4 border-gray-400 p-6 mb-6 italic" data-id="element-7658">
              <p className="text-gray-700 mb-4" data-id="element-7659">
                I bought my 08 F350 Super Cab FX4 in Dec 07 for a couple of
                reasons. I had on 04 F350 with the 6.0 it was fast, MPG was
                about 13 but man you could hear me coming from a mile away. The
                new 6.4 was quiet, dealer told me to expect 15 to 18 MPG and it
                was faster than my 04, with still all of the towing capacity.
                FAST FORWARD to the real world.
              </p>
              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4 not-italic" data-id="element-7660">
                <p className="text-gray-800 font-semibold" data-id="element-7661">Reality Check:</p>
                <ul className="list-disc list-inside space-y-1 text-gray-700" data-id="element-7662">
                  <li data-id="element-7663">Expected: 15-18 MPG</li>
                  <li data-id="element-7664">Actual: 9.5 MPG average</li>
                  <li data-id="element-7665">Towing: 7 MPG</li>
                  <li data-id="element-7666">Miles: 3,700</li>
                </ul>
              </div>
              <p className="text-gray-700" data-id="element-7667">
                I baby this truck, I have 3700 miles on her and I am getting on
                average 9.5 MPG, when I am hauling my trailer I am getting 7
                MPG. And it isn't faster than my 04 F350.
              </p>
            </div>

            {/* Customer Testimonial 2 */}
            <div className="bg-gray-50 border-l-4 border-gray-400 p-6 mb-6 italic" data-id="element-7668">
              <p className="text-gray-700" data-id="element-7669">
                I love the truck, it is tough looking, very quiet and it does
                have good towing capacity, but the mileage is killing me. I am
                even considering a different truck because the mileage is so
                poor. For all of you out there who claim 15 MPG and more, please
                tell me how you are getting it.
              </p>
            </div>

            {/* Customer Testimonial 3 - Detailed Comparison */}
            <div className="bg-gray-50 border-l-4 border-gray-400 p-6 mb-6 italic" data-id="element-7670">
              <h3 className="text-lg font-bold text-gray-900 mb-3 not-italic" data-id="element-7671">
                Comparing 7.3 vs 6.4:
              </h3>

              <p className="text-gray-700 mb-4" data-id="element-7672">
                Love the 7.3. Gave my son my old 1997 F-250 2wd 5-speed 4.10
                gears 7.3 (8,800 GVWR) back when it had 220,000 miles on it.
                244,000 now. Gets 15 around town carrying 1,000 lbs of pool
                chemicals. Gets 20 on the interstate @ about 75mph.
              </p>

              <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-4 not-italic" data-id="element-7673">
                <p className="text-gray-800 font-semibold mb-2" data-id="element-7674">
                  7.3L Performance (1997 F-250):
                </p>
                <ul className="list-disc list-inside space-y-1 text-gray-700" data-id="element-7675">
                  <li data-id="element-7676">Around town: 15 MPG (with 1,000 lbs load)</li>
                  <li data-id="element-7677">Interstate @ 75mph: 20 MPG</li>
                  <li data-id="element-7678">Mileage: 244,000 miles</li>
                </ul>
              </div>

              <p className="text-gray-700 mb-4" data-id="element-7679">
                I bought a 08 6.4 F-250 4 door 2wd automatic 3.73 gears (9,800
                GVWR). I initially got 9.5 to 11.5 mpg around town. At just over
                6,000 miles it bumped up to 12.5 to 13.3 mpg around town. At
                that time it got 16mpg @ 70mph on the interstate highway only. I
                made one trip at 66 mph on cruise and the mileage kept climbing
                until 21.2 mpg. If I pulled off the interstate further than I
                could throw a rock the mileage drops like a rock.
              </p>

              <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-4 not-italic" data-id="element-7680">
                <p className="text-gray-800 font-semibold mb-2" data-id="element-7681">
                  6.4L Performance (2008 F-250):
                </p>
                <ul className="list-disc list-inside space-y-1 text-gray-700" data-id="element-7682">
                  <li data-id="element-7683">Initial around town: 9.5-11.5 MPG</li>
                  <li data-id="element-7684">After 6,000 miles: 12.5-13.3 MPG around town</li>
                  <li data-id="element-7685">Interstate @ 70mph: 16 MPG</li>
                  <li data-id="element-7686">Interstate @ 66mph (cruise): 21.2 MPG</li>
                  <li data-id="element-7687">
                    <strong data-id="element-7688">Warning:</strong> Mileage drops dramatically off
                    interstate
                  </li>
                </ul>
              </div>

              <p className="text-gray-700 mb-4" data-id="element-7689">
                I love the truck. I buy one...pay for 5 years and drive it for
                10. I average 22,000 miles per year. That should easily be
                within the life of my truck. Do I wish the mileage was better?
                You bet! Would I buy a Dodge or Chevy? Nope... Drove both...not
                bad trucks ... just not what I liked. Dodge has a great motor
                but the body feels, sounds, looks and is flimsy in comparison. I
                still like the truck but didn't like the feel. The Chevy just
                didn't have enough room. Stopped right there with it. I even
                drove the Toyota gas motor full size. Tons of power but had a
                cheap look on the inside of the truck. It was a very nice truck
                but I wanted the longevity of a diesel.
              </p>

              <p className="text-gray-700 mb-4" data-id="element-7690">
                I have about 17,000 miles on my 6.4. At 36,000 it will probably
                lose its dpf and get a 5" exhaust. Will check mileage figures
                then.
              </p>

              <p className="text-gray-700 font-bold not-italic text-lg" data-id="element-7691">
                Had a 7.3 got a 6.4 wish I had a 7.3 again!
              </p>
            </div>

            <div className="text-sm text-gray-600 italic" data-id="element-7692">
              <p data-id="element-7693">
                Read more:{' '}
                <a href="http://forums.dieselpowermag.com/70/6651211/power-stroke/anyone-getting-decent-mileage-on-64-power-stroke/page2.html" target="_blank" rel="noopener noreferrer" className="text-[#B1050B] hover:text-[#8A0408] underline" data-id="element-7694">
                  http://forums.dieselpowermag.com
                </a>
              </p>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-7695">
            <h2 className="text-3xl font-bold mb-4" data-id="element-7696">
              Expert 6.4L Powerstroke Service
            </h2>
            <p className="text-xl mb-6" data-id="element-7697">
              Get professional diagnostics and maintenance for your 6.4L
              Powerstroke
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-7698">
              <Phone className="mr-3" size={24} data-id="element-7699" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-7700">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}